// Inquiry.jsx
// お問い合わせ（旧Googleフォームの内製版）。メール/お名前/スポット名/内容を送信。
// 過去のお問い合わせは担当者とのやりとり（スレッド）として表示し、そのまま返信できる。
import { IoChevronBack } from "react-icons/io5";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Post } from '../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { Analytics, Gtag } from '../compornents/Analytics';

const ST_LABEL = { open: '対応中', in_progress: '対応中', closed: '対応済み' };

export const Inquiry = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [spotName, setSpotName] = useState('');
  const [content, setContent] = useState('');
  const [threads, setThreads] = useState([]);   // 過去のお問い合わせ
  const [messages, setMessages] = useState([]); // 全スレッドの発言
  const [openId, setOpenId] = useState(0);      // 展開中のスレッド
  const [replyText, setReplyText] = useState('');
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {});

  // 過去のお問い合わせ（取得と同時に担当者からの返信は既読になる）
  const loadThreads = useCallback(async () => {
    const r = await Post('post', '/customer/inquiry_index.php', {});
    if (r && r.result === 1) {
      setThreads(r.inquiries ?? []);
      setMessages(r.messages ?? []);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 10);
    (async () => {
      const r = await Post('post', '/customer/index.php', {});
      if (r && r.result === 1 && r.customer) {
        const c = r.customer;
        setEmail(c.mail ?? '');
        setName((`${c.first_name ?? ''} ${c.last_name ?? ''}`).trim() || (c.name ?? ''));
      }
      const lp = await Post('post', '/lpspot/index.php', {});
      if (lp && lp.result === 1 && lp.lpspot) setSpotName(lp.lpspot.name ?? '');
      await loadThreads();
    })();
  }, [loadThreads]);

  const back = () => navigate('/account');

  const submit = async () => {
    if (!email.trim()) { toast.error('メールアドレスをご入力ください'); return; }
    if (!name.trim()) { toast.error('お名前をご入力ください'); return; }
    if (!content.trim()) { toast.error('お問い合わせ内容をご入力ください'); return; }
    openLoadingModal();
    const res = await Post('post', '/customer/create_inquiry.php', { email, name, spot_name: spotName, content });
    closeLoadingModal();
    if (res && res.result === 1) {
      Gtag('inquiry_submit');
      toast.success('お問い合わせを受け付けました。担当よりご連絡いたします。');
      navigate('/account');
    } else {
      toast.error((res && res.error_message) || '送信に失敗しました');
    }
  };

  // 既存スレッドへの返信
  const sendReply = async (inquiryId) => {
    if (!replyText.trim()) { toast.error('返信内容をご入力ください'); return; }
    openLoadingModal();
    const res = await Post('post', '/customer/inquiry_reply.php', { inquiry_id: inquiryId, content: replyText.trim() });
    closeLoadingModal();
    if (res && res.result === 1) {
      setReplyText('');
      toast.success('送信しました。担当よりご連絡いたします。');
      await loadThreads();
    } else {
      toast.error((res && res.error_message) || '送信に失敗しました');
    }
  };

  // 担当者からの未読返信があるスレッド
  const hasUnread = (inquiryId) =>
    messages.some((m) => Number(m.inquiry_id) === Number(inquiryId) && m.sender === 'admin' && !m.read_at);

  return (
    <div className="App">
      <div className="Address">
        <Analytics title="お問い合わせ" />
        <div className="toolbar mb-3">
          <div className="toolbar_left div_btn" onClick={back}><IoChevronBack /></div>
          <div className="toolbar_center">お問い合わせ</div>
          <div className="toolbar_right"></div>
        </div>
        <div className="m-4">
          <p className="svy-intro">ご不明な点はこちらからお問い合わせください。</p>
          <div className="svy-q">
            <div className="svy-q-label">メールアドレス</div>
            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="example@email.com" />
          </div>
          <div className="svy-q">
            <div className="svy-q-label">お名前</div>
            <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} placeholder="山田 太郎" />
          </div>
          <div className="svy-q">
            <div className="svy-q-label">スポット名（現在/利用予定）</div>
            <input type="text" className="form-control" value={spotName} onChange={(e) => setSpotName(e.target.value)} placeholder="ご利用のロッカー/店舗名" />
          </div>
          <div className="svy-q">
            <div className="svy-q-label">お問い合わせ内容</div>
            <textarea className="form-control" rows={5} value={content} onChange={(e) => setContent(e.target.value)} placeholder="お問い合わせ内容をご記入ください" />
          </div>
          <div className="mb-5 mt-4">
            <button className="btn btn-oval btn-yellow form-control" onClick={submit}>送信する</button>
          </div>

          {/* これまでのお問い合わせ（担当者とのやりとり） */}
          {threads.length > 0 && (
            <div className="mb-5">
              <div className="h6 mb-2" style={{ fontWeight: 600 }}>これまでのお問い合わせ</div>
              {threads.map((t) => {
                const opened = Number(openId) === Number(t.id);
                const list = messages
                  .filter((m) => Number(m.inquiry_id) === Number(t.id))
                  .sort((a, b) => Number(a.id) - Number(b.id));
                return (
                  <div key={t.id} style={{ border: '1px solid #e5e7eb', borderRadius: 12, padding: 12, marginBottom: 10, background: '#fff' }}>
                    <div className="div_btn" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}
                      onClick={() => { setOpenId(opened ? 0 : t.id); setReplyText(''); }}>
                      <div style={{ minWidth: 0 }}>
                        <div style={{ fontSize: 12, color: '#999' }}>
                          {t.created_at}・{ST_LABEL[t.status] ?? t.status}
                          {hasUnread(t.id) && <span className="text-danger"> New!</span>}
                        </div>
                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.content}</div>
                      </div>
                      <div style={{ color: '#999', fontSize: 12, flexShrink: 0 }}>{opened ? '閉じる' : '開く'}</div>
                    </div>

                    {opened && (
                      <div className="mt-3">
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                          {list.map((m) => {
                            const mine = m.sender === 'customer';
                            return (
                              <div key={m.id} style={{ display: 'flex', justifyContent: mine ? 'flex-end' : 'flex-start' }}>
                                <div style={{ maxWidth: '82%' }}>
                                  <div style={{ fontSize: 11, color: '#999', marginBottom: 2, textAlign: mine ? 'right' : 'left' }}>
                                    {mine ? 'あなた' : '担当者'}
                                  </div>
                                  <div style={{
                                    background: mine ? '#ffe9a8' : '#fff',
                                    border: `1px solid ${mine ? '#f3d77a' : '#e5e7eb'}`,
                                    borderRadius: 14, padding: '8px 12px',
                                    borderTopRightRadius: mine ? 4 : 14, borderTopLeftRadius: mine ? 14 : 4,
                                  }}>
                                    <span style={{ whiteSpace: 'pre-wrap' }}>{m.body}</span>
                                    {(m.imgs || '').split(',').filter(Boolean).map((u, i) => (
                                      <img key={i} src={u} alt="" style={{ maxWidth: 200, borderRadius: 8, display: 'block', marginTop: 6 }} />
                                    ))}
                                  </div>
                                  <div style={{ fontSize: 10, color: '#bbb', marginTop: 2, textAlign: mine ? 'right' : 'left' }}>{m.created_at}</div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        <div className="mt-3">
                          <textarea className="form-control" rows={3} value={replyText}
                            onChange={(e) => setReplyText(e.target.value)} placeholder="担当者への返信を入力" />
                          <button className="btn btn-oval btn-yellow form-control mt-2" onClick={() => sendReply(t.id)}>返信する</button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div><TailSpin stroke="#000" /></div>
            <div>処理中です</div>
          </div>
        </LoadingModal>
        <Tabbar menu="account" />
      </div>
    </div>
  );
};

export default Inquiry;
